import React from 'react';
import { string, array, func } from 'prop-types'
import cn from 'classnames'

import NumberInput from '../settings/NumberInput';

const Quota = ({
  name,
  actions,
  updateQuota,
  clearQuota
}) => {
  return (
    <div>
      <div className="User__header">
        <h3 className="User__header__h3">
          {name} Quota
        </h3>
      </div>
      <div className="Table Table--user-quotas">
        <div className="Table__row">
          <div className="Table__col Table__col--th">Action</div>
          <div className="Table__col Table__col--th">Count</div>
          <div className="Table__col Table__col--th">Limit</div>
          <div className="Table__col Table__col--th">TTL (seconds)</div>
        </div>

        {actions.map((quota) => {
          const r = quota.limit > 0 ? quota.count / quota.limit : 0
          return (
            <div className="Table__row" key={`${name}_${quota.action}`}>
              <div className={cn("Table__col Quota__col", { 'Quota--warning': 1 > r && 0.65 < r, 'Quota--blocked': 1 <= r })}>
                {quota.action}
              </div>
              <div className="Table__col">
                <div>
                  <NumberInput param={quota.action} value={quota.count} updateHandler={updateQuota} />
                </div>
              </div>
              <div className="Table__col Quota__col">
                {quota.limit}
              </div>
              <div className="Table__col Quota__col">
                {quota.ttl || '-'}
                {quota.ttl && <button type="button" className="Quota__remove_button" onClick={() => clearQuota(quota.action)} />}
              </div>
            </div>
          )
        })}
      </div>
      <br />
    </div>
  )
}

Quota.propTypes = {
  name: string.isRequired,
  actions: array.isRequired,
  updateQuota: func.isRequired,
  clearQuota: func.isRequired
}

export default Quota;
